const stylePoll = setInterval(() => {
  const wrapper = document.querySelector(".b2b-link");
  const formRenderer = wrapper.querySelector("#app-embed");
  if (formRenderer && formRenderer.shadowRoot) {
    clearInterval(stylePoll);
    const style = document.createElement("style");
    style.textContent = `
    
    label._formInputFieldLabel_1ydxd_37 {
      color: rgb(25, 25, 25) !important;
      font-family: var(--primary-font-body-family) !important;
      font-weight: 500 !important;
      font-size: 10px !important;
      line-height: 100% !important;
      letter-spacing: 0px !important;
    }

    ._checkboxField_171zd_1 ._textBody_2aowh_10 {
      font-family: var(--primary-font-body-family) !important;
      font-size: 12px !important;
      letter-spacing: 0px !important;
      line-height: 19.2px !important;
      margin-left: 12px !important;
    }

    ._verticalLayout_171zd_6 {
      gap: 12px !important;
    }

    ._checkboxInput_171zd_31 {
      box-sizing: border-box !important;
      margin: 0 !important;
      accent-color: var(--color-brand-primary) !important;
      height: 24px !important;
      width: 24px !important;
    }

    ._inline_stahb_47 ._formContainer_stahb_30 {
      max-width: 100% !important;
      width: 100% !important;
    }

    ._formDisclaimer_1nihh_33 {
      font-weight: 600 !important;
      font-size: 12px !important;
      line-height: 18px !important;
      letter-spacing: 0px !important;
      font-family: var(--primary-font-body-family) !important;
    }

    ._textBody_2aowh_10,
    label._formInputFieldLabel_1ydxd_37 {
      font-weight: 400 !important;
      font-size: 10px !important;
      line-height: 24px !important;
      letter-spacing: 0px !important;
      font-family: var(--primary-font-body-family) !important;
      color: var(--color-brand-secondary-light) !important;
    }
    
    input._formInputField_237zm_7 {
      font-size: 15px !important;
      font-weight: 400 !important;
      line-height: 160% !important;
      letter-spacing: 0px !important;
    }
    form._formFieldset_8skcf_76{
    padding: 2px !important;
    }

    ._formFieldContainer_1ydxd_5 {
      max-height: 48px !important;
    }

    ._formFieldContainer_1ydxd_5 input {
      font-family: var(--primary-font-body-family) !important;
      line-height: 160% !important;
      font-size: 15px !important;
      letter-spacing: 0px !important;
      color: var(--color-brand-secondary) !important;
      height: 48px !important;
    }

    ._formFieldset_ed7ce_68 {
      gap: 12px !important;
      padding: 1px 2px !important;
    }

    ._inline_stahb_47 button._formSubmitButton_ed7ce_82 {
      font-family: var(--primary-font-body-family) !important;
      font-size: 14px !important;
      font-style: normal !important;
      font-weight: 400 !important;
      line-height: normal !important;
      letter-spacing: 0 !important;
      background: rgba(127, 17, 131, 1) !important;
    }

    ._formError_1ydxd_20,
    ._error_1o4ef_1 {
      display: none !important;
    }

    label._formInputFieldLabel_1ydxd_37 {
        color: var(--color-brand-secondary-light) !important;
        font-size: 15px !important;
    }
          
    label._formInputFieldLabel_1ydxd_37:focus-within,
        label._formInputFieldLabel_1ydxd_37:focus {
        font-size: 10px !important;
    }    

    @media screen and (max-width: 749px) {
      ._inline_stahb_47 ._formContainer_stahb_30 {
        min-width: 335px !important;
      }

      label._formInputFieldLabel_1ydxd_37 {
        color: rgb(25, 25, 25) !important;
        font-family: var(--primary-font-body-family) !important;
        font-weight: 500 !important;
        font-size: 10px !important;
        line-height: 100% !important;
        letter-spacing: 0px !important;
      }

      label._formInputFieldLabel_1ydxd_37 {
        color: var(--color-brand-secondary-light) !important;
        font-size: 15px !important;
      }
          
      label._formInputFieldLabel_1ydxd_37:focus-within,
        label._formInputFieldLabel_1ydxd_37:focus {
        font-size: 10px !important;
      } 
    }
     
      `;
    formRenderer.shadowRoot.appendChild(style);
  }
}, 100);

// Below coed is for field orientation

function groupNameFields() {
  const formRenderer = document.querySelector("#app-embed");
  if (!formRenderer || !formRenderer.shadowRoot) return;

  const shadowRoot = formRenderer.shadowRoot;

  // --- Group first and last name fields in a flex wrapper ---
  const lastName = shadowRoot.getElementById("last_name");
  const firstName = shadowRoot.getElementById("first_name");

  // Get their parent divs
  const lastNameParent = lastName ? lastName.closest("div") : null;
  const firstNameParent = firstName ? firstName.closest("div") : null;

  // Remove existing wrapper if present to avoid duplicates
  const existingWrapper = shadowRoot.querySelector(".name-fields-wrapper");
  if (existingWrapper && existingWrapper.parentNode) {
    while (existingWrapper.firstChild) {
      existingWrapper.parentNode.insertBefore(
        existingWrapper.firstChild,
        existingWrapper
      );
    }
    existingWrapper.parentNode.removeChild(existingWrapper);
  }

  // Add classes for styling
  if (lastNameParent) lastNameParent.classList.add("last-name-group");
  if (firstNameParent) firstNameParent.classList.add("first-name-group");

  // Only apply on screens wider than 990px
  if (window.innerWidth > 990 && firstNameParent && lastNameParent) {
    const wrapper = document.createElement("div");
    wrapper.className = "name-fields-wrapper";
    wrapper.style.display = "flex";
    wrapper.style.gap = "12px";
    wrapper.style.justifyContent = "space-between";
    firstNameParent.style.width = "50%";
    lastNameParent.style.width = "50%";

    // Insert wrapper before the first of the two parents
    const parent = firstNameParent.parentNode;
    parent.insertBefore(wrapper, firstNameParent);
    wrapper.appendChild(firstNameParent);
    wrapper.appendChild(lastNameParent);
  } else {
    // On mobile, reset widths if needed
    if (firstNameParent) firstNameParent.style.width = "";
    if (lastNameParent) lastNameParent.style.width = "";
  }

  // Disabling legend Acceptance Confirmed

  // Add a custom class to the legend for easier targeting and hide it
  const legends = shadowRoot.querySelectorAll(
    "legend._textBody_2aowh_10._checkboxLegend_171zd_18"
  );
  legends.forEach((legend) => {
    legend.classList.add("custom-hide-legend");
    legend.style.display = "none";
  });

  const checkboxLabel = shadowRoot.querySelectorAll("._checkboxField_171zd_1");
  checkboxLabel[1].classList.add("custom-hide-label");
  checkboxLabel[1].style.display = "none";

  // --- Custom error alert on button click if error classes are present ---

  const submitButton = shadowRoot.querySelector(
    "button._formSubmitButton_ed7ce_82"
  );
  if (submitButton) {
    submitButton.addEventListener("click", function () {
      setTimeout(() => {
        const hasError =
          shadowRoot.querySelector("._withError_1ydxd_16") ||
          shadowRoot.querySelector("._selectorError_1yit2_50");
        // Remove any previous custom error message
        const existingMsg = shadowRoot.getElementById("custom-mandatory-msg");
        if (existingMsg) existingMsg.remove();

        // ...existing code...
        // --- Acceptance Confirmed checkbox validation ---
        const acceptanceCheckbox = shadowRoot.querySelector(
          'input[type="checkbox"][name="custom#acceptance_confirmed"]'
        );
        if (acceptanceCheckbox && !acceptanceCheckbox.checked) {
          const msgDiv = document.createElement("div");
          msgDiv.id = "custom-mandatory-msg";
          const p = document.createElement("p");
          p.textContent = "*Please confirm acceptance to proceed";
          p.style.color = "#d32f2f";
          p.style.margin = "0";
          p.style.fontWeight = "bold";
          msgDiv.appendChild(p);
          submitButton.parentNode.insertBefore(
            msgDiv,
            submitButton.nextSibling
          );
          return; // Stop further submission/error checks
        }
        if (hasError) {
          // Create the div and p
          const msgDiv = document.createElement("div");
          msgDiv.id = "custom-mandatory-msg";
          const p = document.createElement("p");
          p.textContent = "*Please fill all the mandatory fields";
          p.style.color = "#d32f2f";
          p.style.margin = "0";
          p.style.fontWeight = "bold";

          msgDiv.appendChild(p);

          // Insert after the button
          submitButton.parentNode.insertBefore(
            msgDiv,
            submitButton.nextSibling
          );
        }
      }, 50); // Wait for DOM update
    });
  }

  // ...existing code...

  if (submitButton) {
    // 1. Disable the button initially
    submitButton.disabled = true;
    submitButton.style.opacity = "0.4";
    submitButton.style.pointerEvents = "none";

    // 2. Function to check if all mandatory fields are filled
    function checkMandatoryFields() {
      // List all mandatory field selectors
      const mandatorySelectors = ["#first_name", "#company_name", "#email"];
      let allFilled = true;
      for (const sel of mandatorySelectors) {
        const el = shadowRoot.querySelector(sel);
        if (!el || !el.value || el.value.trim() === "") {
          allFilled = false;
          break;
        }
      }
      // Acceptance checkbox
      const acceptanceCheckbox = shadowRoot.querySelector(
        'input[type="checkbox"][name="custom#acceptance_confirmed"]'
      );
      if (!acceptanceCheckbox || !acceptanceCheckbox.checked) {
        allFilled = false;
      }
      // Enable/disable button
      submitButton.disabled = !allFilled;
      submitButton.style.opacity = allFilled ? "1" : "0.4";
      submitButton.style.pointerEvents = allFilled ? "auto" : "none";
    }

    // 3. Attach listeners to all mandatory fields
    const fieldsToWatch = [
      "#first_name",
      "#company_name",
      "#email",
      'input[type="checkbox"][name="custom#acceptance_confirmed"]',
    ];
    fieldsToWatch.forEach((sel) => {
      const el = shadowRoot.querySelector(sel);
      if (el) {
        el.addEventListener("input", checkMandatoryFields);
        el.addEventListener("change", checkMandatoryFields);
      }
    });

    // 4. Run check on load
    checkMandatoryFields();

    // ...existing click event listener...
  }

  // ...existing code...
}
// Wait for shadow DOM to be ready, then apply grouping
const groupFieldsPoll = setInterval(() => {
  const formRenderer = document.querySelector("#app-embed");
  if (formRenderer && formRenderer.shadowRoot) {
    clearInterval(groupFieldsPoll);
    groupNameFields();
    window.addEventListener("resize", groupNameFields);
  }
}, 100);
